// extracted by mini-css-extract-plugin
module.exports = {"topContainer":"TopContainer_topContainer__B3OC8","white":"TopContainer_white__XeuDi","widgetsOffset":"TopContainer_widgetsOffset__i91LY","collapse":"TopContainer_collapse__oka0j"};